import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import {
  ImageWrapper,
  StyledImage,
  InfoText,
} from "./MobileCompareImage.styles"

const MobileCompareImage = ({
  beforeImage,
  afterImage,
  beforeImageAlt,
  afterImageAlt,
}) => {
  const [showAfter, setShowAfter] = useState(false)
  useEffect(() => setShowAfter(false), [beforeImage, afterImage])

  return (
    <ImageWrapper
      as="button"
      type="button"
      style={{
        width: "100%",
        padding: 0,
        border: 0,
        background: "transparent",
      }}
      aria-label={`${showAfter ? "Show before image" : "Show after image"}: ${
        showAfter ? beforeImageAlt : afterImageAlt
      }`}
      onClick={() => setShowAfter((value) => !value)}
    >
      <StyledImage
        src={showAfter ? afterImage : beforeImage}
        alt={showAfter ? afterImageAlt : beforeImageAlt}
      />
      <InfoText>
        {showAfter ? "Show before image" : "Show after image"}
      </InfoText>
    </ImageWrapper>
  )
}

MobileCompareImage.propTypes = {
  beforeImage: PropTypes.string.isRequired,
  afterImage: PropTypes.string.isRequired,
  beforeImageAlt: PropTypes.string.isRequired,
  afterImageAlt: PropTypes.string.isRequired,
}

export default MobileCompareImage
